import React from 'react';
import PropTypes from 'prop-types';
import { Panel, PanelType } from '@fluentui/react';
import Navigation from './Navigation';

function SidebarMobile({ isOpen, dismissPanel }) {
  return (
    <Panel
      isOpen={isOpen}
      type={PanelType.smallFixedNear}
      onDismiss={dismissPanel}
      closeButtonAriaLabel="Close"
      hasCloseButton={false}
      isLightDismiss={true}
      className="drawer drawer--mobile"
    >
      <Navigation />
    </Panel>
  );
}

SidebarMobile.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  dismissPanel: PropTypes.func.isRequired,
};

export default SidebarMobile;
